const routerArr = [
    {
        path: '/mh_homepage',
        name: 'mh_homepage',
        meta: { title:'咚咚燕门户首页' , login:false },
        component: () => import(/* webpackChunkName: 'mh_homepage' */ './page/homepage.vue'),
    }
]

export default routerArr;